import { darken } from 'polished';
import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';
import { ObjectManager } from '../../../concepts/objects';
import { Colors } from '../../../ui';
import { Emoji } from '../../../ui/emoji';
import { useResolve } from '../../Container';
import { ProfileModel } from '../../ProfileModel';
import { Reaction } from '../reactions/Reaction';

const Frame = styled.div<{ clickable: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 1.125rem;
    background: ${Colors.l1};
    border-radius: .25rem;
    padding: .25rem;
    user-select: none;

    ${p => p.clickable && css`
        cursor: pointer;
        &:hover {
            background: ${darken(.1, Colors.l1)};
        }
        &:active {
            background: ${darken(.2, Colors.l1)};
        }
    `}
`;

const Count = styled.div`
    margin-left: .25rem;
    font-size: .8125rem;
    font-weight: 500;
    color: ${Colors.text};
`;

const Base = React.memo<{ emoji: string, reactions: Reaction[] }>(({ emoji, reactions }) => {
    const objects = useResolve(ObjectManager);
    const me = useResolve(ProfileModel);
    const canRemove = reactions.some(r => r.userId === me.id);

    const onRemove = useCallback(() => {
        const rc = reactions.find(r => r.userId === me.id);
        if (rc) {
            objects.update(u => {
                u.set('history', 'skip');
                u.delete(rc.removeSelf());
            });
        }
    }, [reactions]);

    return <Frame clickable={canRemove} onClick={onRemove}>
        <Emoji idOrCode={emoji} />
        <Count>{reactions.length}</Count>
    </Frame>;
});

export const ReactionGroup = Object.assign(Base, { Frame });
